import { SET_PAGE_TITLE, SET_SIDER_WIDTH, SET_TIME_ZONE } from "../_types";
import { hp } from "../../utils";
export function setPageTitle(intl, title) {
  // intl.formatMessage(cw.signInFailed)
  return (dispatch) => {
    dispatch({ type: SET_PAGE_TITLE, title: title });
  };
}

export function setSiderWidth(width) {
  return (dispatch) => {
    dispatch({ type: SET_SIDER_WIDTH, width });
  };
}
